const rates = {
  forms: {
    information: {
      details: {
        fields: {
          supplierId: {
            name: 'Flotten',
          },
        },
      },
    },
  },
};

export default rates;
